//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";


// custom pages
import { styles } from "./styles";
import screen from "apis/screen/screen";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

//Helpers
import {dateFormat} from "helpers/dataFormat"

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function View(props) {
  const { state, dispatch } = useContext(Context);
  const { updateScreen } = screen();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  
  const [states, setstates] = useState({
    screenName: "",
    screenPath: "",
    module:"",
    isActive: true,
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
    roles: [],
  });

  const {
    screenName,
    screenPath,
    module,
    isActive,
    data,
    edittedData,
    isEdit,
    loading,
    roles,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      screenName: dataObj?.screen_name,
      screenPath: dataObj?.screen_path,
      module:dataObj?.module,
      isActive: dataObj?.is_active,
      initialRoles: dataObj.roles.map(i => {
        if (dataObj?.screenMapping.find(j => j.role_id == i.role_id ) != null) {
          return {
            role_id: i.role_id,
            role_name: i.role_name,
            value: true
          }
        } else {
          return {
            role_id: i.role_id,
            role_name: i.role_name,
            value: false
          }
        }
      }),
      roles: dataObj.roles.map(i => {
        if (dataObj?.screenMapping.find(j => j.role_id == i.role_id && j.is_active==true) != null) {
          return {
            role_id: i.role_id,
            role_name: i.role_name,
            value: true
          }
        } else {
          return {
            role_id: i.role_id,
            role_name: i.role_name,
            value: false
          }
        }
      }),
    });
  };

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "SCREEN", "VIEW"],
    });
  }, []);

  const handleUpdateScreen = async () => {
    try {
      const editedRoles = roles.filter(i => states?.initialRoles?.find(j => (j.role_id == i.role_id) && (j.value != i.value)))
      if (Object.keys(edittedData).length === 0 && editedRoles.length == 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }
      let failed = false;
      Object.keys(edittedData).map((o) => {
        if (!edittedData[o] && typeof edittedData[o] != "boolean") {
          failed = true;
        }
      });
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        setStates({ loading: false });
        return;
      }

      let values;
      values = {
        ...edittedData,
        screenId: data?.screen_id,
      };

      if (editedRoles.length > 0) {
        values = { ...values, editedRoles }
      }

      let res = await updateScreen(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "rule-updated" });
        history.goBack();
      }
      setStates({ loading: false, isEdit: false });
    }
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            <strong> {'Screen ID'} :</strong> {data?.screen_id}
          </span>
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
              {'Edit'}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Screen Name'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={screenName}
                    onChange={(e) => {
                      setStates({
                        screenName: e.target.value,
                        edittedData: {
                          ...edittedData,
                          screenName: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{screenName}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Screen Path'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={screenPath}
                    onChange={(e) => {
                      setStates({
                        screenPath: e.target.value,
                        edittedData: {
                          ...edittedData,
                          screenPath: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{screenPath}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Module Name'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={module}
                    onChange={(e) => {
                      setStates({
                        module: e.target.value,
                        edittedData: {
                          ...edittedData,
                          module: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{module}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {'Is Active'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    id={"Is Active"}
                    select
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={isActive}
                    onChange={(e) => {
                      setStates({
                        isActive: e.target.value,
                        edittedData: {
                          ...edittedData,
                          isActive: e.target.value,
                        },
                      });
                    }}
                  >
                    {[
                      { label: "True", value: true },
                      { label: "False", value: false },
                    ].map((t, i) => (
                      <MenuItem value={t.value} key={i}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </CssTextField>
                ) : <span className={classes.label}>{isActive.toString()}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={0} item xs={8}>
          <Grid item xs={4}>
            <strong className={classes.label}> {'Roles'} : </strong>
          </Grid>
          <Grid item xs={4}>
            <FormGroup>{
              roles?.slice(0, 6)?.map(i => {
                return <FormControlLabel
                  key={i.role_id}
                  control={
                    <Checkbox
                      color="primary"
                      checked={i.value}
                      onChange={(e) => {
                        let arr = [...roles];
                        let index = arr.findIndex(k => k.role_id == i.role_id);
                        if (e.target.checked) {
                          arr[index].value = true
                        } else {
                          arr[index].value = false
                        }
                        setStates({ ...states, roles: arr })
                      }}
                    />
                  }
                  label={i.role_name}
                  disabled={!isEdit}
                />
              })}
            </FormGroup>
          </Grid>
          <Grid item xs={4}>
            <FormGroup>{
              roles?.slice(6,)?.map(i => {
                return <FormControlLabel
                  key={i.role_id}
                  control={
                    <Checkbox
                      color="primary"
                      checked={i.value}
                      onChange={(e) => {
                        let arr = [...roles];
                        let index = arr.findIndex(k => k.role_id == i.role_id);
                        if (e.target.checked) {
                          arr[index].value = true
                        } else {
                          arr[index].value = false
                        }
                        setStates({ ...states, roles: arr })
                      }}
                    />
                  }
                  label={i.role_name}
                  disabled={!isEdit}
                />
              })}
            </FormGroup>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {
            isEdit && (
              <Fragment>
                <Button
                  className={classes.cancelBtn}
                  onClick={() => {
                    setDataObj(data);
                    setStates({ isEdit: false, edittedData: {} });
                  }}
                >
                  {'Cancel'}
                </Button>
                &nbsp; &nbsp; &nbsp;
                <Button
                  className={classes.submitBtn}
                  onClick={() => {
                    setStates({ loading: true });
                    handleUpdateScreen();
                  }}
                  disabled={loading}
                >
                  {'Update'}
                </Button>
              </Fragment>
            )
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
